import { parseCurrency } from "~/utils/formatters";

const looksLikeExplicitZeroValueUsd = (trimmed: string): boolean => {
  const normalized = trimmed.replace(/,/g, "").replace(/\s+/g, "");
  return /^(?:[$€£¥₹(]*0(?:\.0+)?[)]*)$/.test(normalized);
};

/** Validation message for modal Value (USD); null when empty or parseable. */
export const getBorderUsModalValueUsdParseError = (valueUsd: string | undefined): string | null => {
  const trimmed = valueUsd?.trim() ?? "";
  if (trimmed === "") {
    return null;
  }
  if (/[A-Za-z]/.test(trimmed)) {
    return "Enter a valid Value (USD) amount or leave the field empty to use the order line cost.";
  }
  const centsStr = parseCurrency(trimmed);
  if (centsStr === "0" && !looksLikeExplicitZeroValueUsd(trimmed)) {
    return "Enter a valid Value (USD) amount or leave the field empty to use the order line cost.";
  }
  const centsNum = Number(centsStr);
  if (!Number.isFinite(centsNum)) {
    return "Enter a valid Value (USD) amount or leave the field empty to use the order line cost.";
  }
  if (!Number.isInteger(centsNum)) {
    return "Value (USD) may have at most two decimal places.";
  }
  return null;
};
